export class AppVersion {
  public version: string
  public segments: number[] = []

  constructor(version: string) {
    this.version = version || ''
    this.segments = this.version.split('.').map((segment) => Number(segment))
  }

  static isEqualOrHigherThan(current: string, target: string) {
    return new AppVersion(current).isEqualOrHigherThan(new AppVersion(target))
  }

  isEqual(version: AppVersion) {
    return this.version === version.version
  }

  isHigherThan(version: AppVersion) {
    let i = 0

    for (; i < this.segments.length && i < version.segments.length; i++) {
      if (this.segments[i] > version.segments[i]) {
        return true
      }
      if (this.segments[i] < version.segments[i]) {
        return false
      }
    }

    return i !== this.segments.length
  }

  isEqualOrHigherThan(version: AppVersion) {
    return this.isEqual(version) || this.isHigherThan(version)
  }
}
